import React, { useContext, useState, useEffect, useMemo } from 'react'
import { Flex, Box } from 'reflexbox'
import { ThemeContext } from 'styled-components'
import { useParams, Link } from 'react-router-dom'

import { toast } from 'react-toastify'

import Breadcrumb from 'components/Breadcrumb'
import Button from 'components/Button'
import { ActivateGroupModal } from 'components/Modal'
import { SemiTitle, Text } from 'components/Typography'

import BeneficiariesDataListing from 'containers/BeneficiariesDataListing'

import { getGroupInfo, deleteGroupBeneficiary, activateGroup } from 'services/groups'

const Show = () => {
  const theme = useContext(ThemeContext)
  const { id: groupID } = useParams()
  const [groupData, setGroupData] = useState({})
  const [confirmationModalisOpened, setConfirmationModalIsOpened] = useState(false)
  const [groupToBeActivated, setGroupToBeActivated] = useState(null)

  const breadcrumbPath = useMemo(
    () => [
      {
        label: 'Grupos de beneficiários',
        link: '/prepaid-purchase/groups',
      },
      {
        label: groupData?.name,
      },
    ],
    [groupData],
  )

  useEffect(() => {
    const getGroupData = async () => {
      try {
        const { data } = await getGroupInfo(groupID)
        setGroupData(data)
      } catch (e) {
        console.log(e)
        toast.error('Não foi possível carregar os dados do grupo no momento.')
      }
    }

    getGroupData()
  }, [confirmationModalisOpened])

  return (
    <Flex flexDirection='column' width={1}>
      <Breadcrumb children={breadcrumbPath} />

      {groupData?.name && (
        <Flex width={1} justifyContent='space-between'>
          <h1>{groupData?.name}</h1>
          <Flex width={2 / 3} alignItems='center' justifyContent='flex-end'>
            <Button
              variant='secondary'
              size='big'
              as={Link}
              to={`/prepaid-purchase/groups/attribution/new/${groupData?.name}/${groupID}`}
              mr={24}
            >
              Adicionar beneficiário
            </Button>
            <Button
              variant={groupData.is_active ? 'tertiary' : 'primary'}
              onClick={() => {
                setConfirmationModalIsOpened(true)
                setGroupToBeActivated(groupData)
              }}
            >
              {groupData.is_active ? 'Desativar' : 'Ativar'}
            </Button>
          </Flex>
        </Flex>
      )}
      <Flex width={1} justifyContent='space-between'>
        <Flex justifyContent='space-between' mb={32}>
          <Box width={1 / 2} mr={24}>
            <SemiTitle color={theme.colors.grays.N500}>Pacotes de canais</SemiTitle>
            <Text>{groupData?.packages_list?.map(plan => plan.name).join(', ')}</Text>
          </Box>
          <Box width={1 / 2}>
            <SemiTitle color={theme.colors.grays.N500}>Beneficiários</SemiTitle>
            <Text>{groupData?.beneficiaries?.length} clientes</Text>
          </Box>
        </Flex>
        {groupData?.beneficiaries?.length === 0 && (
          <Button as={Link} to={`/prepaid-purchase/groups/edit/${groupID}`} outlined>
            Editar
          </Button>
        )}
      </Flex>

      <BeneficiariesDataListing groupID={Number(groupID)} />

      <ActivateGroupModal
        isOpened={confirmationModalisOpened}
        setIsOpened={setConfirmationModalIsOpened}
        group={groupToBeActivated}
      />
    </Flex>
  )
}

export default Show
